import React, { ReactElement } from "react";

function ProductCampaigns(): ReactElement {
    return null; // Not Implemented Yet
}

export default ProductCampaigns;
